module.exports = __webpack_public_path__ + "static/img/poster.5cf45c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/images/poster.png
// module id = U9gU
// module chunks = 1